(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireb86c"];
var parcelRegister = parcelRequire.register;
parcelRegister("iONh6", function(module, exports) {

$parcel$export(module.exports, "initHeroSectionSplide", function () { return $e0155e0f924ed2a3$export$e3e7daf394f93a30; });
// Splide

var $9yyrO = parcelRequire("9yyrO");
const $e0155e0f924ed2a3$export$e3e7daf394f93a30 = (containerEl)=>{
    if (!containerEl) return;
    const isAutoPlay = containerEl.getAttribute("data-autoplay") == "True" ? true : false;
    const selectedInterval = containerEl.getAttribute("data-interval")?.length > 0 ? Number(containerEl.getAttribute("data-interval")) : 5000;
    var heroSplide = new (0, $9yyrO.default)(containerEl, {
        type: 'loop',
        autoplay: isAutoPlay,
        interval: selectedInterval,
        resetProgress: false
    });
    heroSplide.on('overflow', function(isOverflow) {
        heroSplide.options = {
            arrows: isOverflow,
            drag: isOverflow
        };
    });
    heroSplide.mount();
};

});

})();
//# sourceMappingURL=initHeroSectionSplide.23f4f672.js.map
